import React from 'react'

const Button = (props) => {
  return (
    <button type={props.type || "button"} className={props.className} onClick={props.onClick}>
      {props.icon} {props.name}
    </button>
  )
}

export default Button;
